<template>
  <v-app id="inspire" class="bodyPadding">
    <mo-header></mo-header>
    <v-content>
      <rep-head></rep-head>
      <rep-list></rep-list>
    </v-content>
  </v-app>
</template>

<script>

  import RepHead from './../child_components/Header.vue';
  import RepList from './List.vue';
  export default {
    data() {
      return {

      }
    },
    components: {
      RepHead,
      RepList
    }
  }
</script>

<style scoped>
  @import '../../shared/assets/css/shared.css'
</style>